import { render } from "./ScreenerModal.vue?vue&type=template&id=06924d83&ts=true"
import script from "./ScreenerModal.vue?vue&type=script&lang=ts"
export * from "./ScreenerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__